import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Home/Header';
import Footer from './Home/Footer';
// import Popup from '../components/Popup';

function Main() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* <Popup title="[비대면] 동기면담 실습 강의 신청자분들께 안내드립니다">
                <Typography variant="body1" color="text.primary" sx={{ whiteSpace: 'pre-line', lineHeight: 2 }}>
                    {`홈페이지 오류로 인해 일부 신청자 정보가 누락되는 문제가 발생하였습니다.\n이로 인해 불편을 드린 점 진심으로 사과드립니다.\n\n강의 입금을 완료하신 분들께서는 아래 연락처로 문의해 주시면\n신속히 처리해 드리겠습니다.`}
                </Typography>
                <Box sx={{ mt: 2.5, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold" color="text.primary" lineHeight={2}>
                        📞 010-9424-3355{'\n'}✉️ psych@garam-mind.com
                    </Typography>
                </Box>
            </Popup> */}
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Outlet />
            </Box>
            <Footer />
        </Box>
    );
}

export default Main;
